import $ from "jquery";

const loginFunctionality = () => {
    // toggle password visibility
    $(".js-see-password").on("click", function (e) {
        e.preventDefault();
        $(this).find(".js-icon").toggleClass("fa-eye fa-eye-slash");
        var $input = $(".js-login-password");
        $input.attr(
            "type",
            $input.attr("type") === "password" ? "text" : "password"
        );
    });

    // show forgot password form
    $(".js-forgot-password-trigger").on("click", function (e) {
        e.preventDefault();
        $(".js-login-form").addClass("d-none");
        $(".js-request-reset-form").removeClass("d-none");
    });
};

export default loginFunctionality;
